import type { DateRange } from '@/entities/query';
import { useSearch } from '@tanstack/react-router';
import dayjs from 'dayjs';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';

export const FILTERED_PAGE_START_DATE_KEY = 'filtered_page_start_date';
export const FILTERED_PAGE_END_DATE_KEY = 'filtered_page_end_date';

export const filteredPageDateRangeAtom = atom<DateRange>({
  startDate: dayjs().subtract(1, 'month').toJSON(),
  endDate: dayjs().toJSON(),
});

export function useFilteredPageDateRangeValue() {
  const dateRange = useAtomValue(filteredPageDateRangeAtom);
  const { [FILTERED_PAGE_START_DATE_KEY]: startDate, [FILTERED_PAGE_END_DATE_KEY]: endDate } =
    useSearch({ strict: false });
  if (startDate && endDate) {
    return {
      startDate: dayjs(startDate).toJSON(),
      endDate: dayjs(endDate).toJSON(),
    };
  }
  return dateRange;
}

export function useFilteredPageDateRangeSetter() {
  const setDateRangeAtom = useSetAtom(filteredPageDateRangeAtom);

  const setDateRange = useCallback(
    (dateRange: DateRange, searchParams: URLSearchParams) => {
      setDateRangeAtom(dateRange);
      searchParams.set(FILTERED_PAGE_START_DATE_KEY, dateRange.startDate);
      searchParams.set(FILTERED_PAGE_END_DATE_KEY, dateRange.endDate);
    },
    [setDateRangeAtom],
  );

  return setDateRange;
}
